<style lang="scss" scoped>
  @import "~@/assets/css/constant.scss";

  .main {
    width: 100%;
    height: 100%;
    background: #fff none no-repeat center center;
    background-image: url(~@/assets/image/bg.png);
    background-size: cover;
    color: #fff;
    header {
      padding: 20px 45px;
      .logo {
        font-size: 30px;
      }
      .user {
        float: right;
        a {
          text-decoration: none;
          color: #fff;
          margin-left: 10px;
        }
      }
    }
    .container {
      position: absolute;
      left: 0;
      top: 38%;
      width: 100%;
      text-align: center;
      z-index: 2;
      .slogan {
        width: 880px;
        height: 122px;
        background: url(~@/assets/image/slogan.png) no-repeat 0 0;
        display: inline-block;
        background-size: 100%;
      }
      .content {
        text-align: center;
        width: 720px;
        margin: 50px auto 0;
        .tip {
          font-size: 16px;
          text-align: left;
          padding: 0 20px 20px;
        }
        .item {
          position: relative;
          display: inline-block;
          margin: 0 20px;
          width: 320px;
          height: 50px;
          line-height: 50px;
          color: white;
          font-size: 16px;
          background: $green;
          border-radius: 4px;
          float: left;
          overflow: hidden;
          .icon-font {
            vertical-align: middle;
            font-size: 20px;
          }
          .name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 10px;
          }
          .supplier-list {
            display: none;
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            max-height: 0;
            overflow: hidden;
            max-height: 308px;
            background: $green;
            border-radius: 4px;
            overflow: auto;
            z-index: 2;
            .supplier {
              font-size: 14px;
              height: 44px;
              line-height: 44px;
              cursor: pointer;
              &.selected,&:hover {
                background: rgba(255, 255, 255, 0.12);
              }
            }
          }
          &.hover {
            overflow: visible;
            .supplier-list {
              display: block;
            }
          }
          &.error {
            background: rgb(110, 110, 110);
          }
          .supplier-list::-webkit-scrollbar {/*滚动条整体样式*/
            display: none;
          }
        }
      }
    }
  }
</style>

<template>
  <div class="main">
    <header class="clearfix">
      <span class="logo iconfont icon-meicailogo"></span>
      <span class="user">你好，<strong>{{loginSupplier.passportPhone}}</strong> <a href="/sweb/login/loginOut">退出</a></span>
    </header>
    <div class="container">
      <div class="slogan"></div>
      <div class="content">
        <div class="tip">{{tip}}</div>
        <div class="selector clearfix">
          <div :class="['item', 'suppliers', supplierHover ? 'hover' : '', tipClass ]" @mouseenter="toggleSupplierHover(true)" @mouseleave="toggleSupplierHover(false)">
            <div class="name">
              <span v-show="!selectedSupplier.name" class="iconfont icon-person"></span>
              {{selectedSupplier.name ? `${selectedSupplier.supplierNo}-${selectedSupplier.name}` : '请选择供应商'}}
            </div>
            <div class="supplier-list" v-if="suppliers.length > 0">
              <div class="supplier name" v-for="item in suppliers" :key="item.fSupplierBasic" @click="chooseSupplier(item)">{{item.supplierNo}}-{{item.name}}</div>
            </div>
          </div>
          <div :class="['item', 'citys', cityHover ? 'hover' : '', tipClass]" @mouseenter="toggleCityHover(true)" @mouseleave="toggleCityHover(false)">
            <div class="name">
              <span v-show="!selectedSupplierCityStr" class="iconfont icon-location"></span>
              {{selectedSupplierCityStr ? selectedSupplierCityStr : '请选择城市'}}
            </div>
            <div class="supplier-list">
              <div class="supplier name" v-for="item in selectedSupplier.supList" :key="item.id" @click="chooseCity(item)">{{item.cityStr}}</div>
            </div>
          </div>
        </div>
        <!-- 请选择公司主体 -->
        <div class="selector clearfix" style="margin-top: 20px">
          <!--  -->
           <div :class="['item', 'suppliers', supplierFrameHover ? 'hover' : '', tipFrameClass ]"  @mouseenter="toggleFrameSupplierHover(true)" @mouseleave="toggleFrameSupplierHover(false)">
            <div class="name">
              <span v-show="!selectedFrameSupplier.name" class="iconfont icon-person"></span>
              {{selectedFrameSupplier.bizName ? `${selectedFrameSupplier.bizCode}-${selectedFrameSupplier.bizName}` : '请选择公司主体'}}
            </div>
            <div class="supplier-list" v-if="frameSuppliers.length > 0">
              <div class="supplier name" v-for="item in frameSuppliers" :key="item.bizCode" @click="chooseFrameSupplier(item)">{{item.bizName}}</div>
            </div>
          </div>
        </div>
        <!-- 尚未入住 -->
        <div class="tip" style="marginTop: 20px">尚未入住</div>
        <div class="selector clearfix">
          <div class="item" style="cursor: pointer">
            <div class="name" @click="supplierPoolInfo">
              意向合作基本信息填写
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'selectSupplier',
  data () {
    return {
      tipClass: '',
      tip: '已入驻（请先选择供应商）',
      tipFrameClass: '',
      tipFrame: '请选择公司主体',
      supplierHover: false,
      supplierFrameHover: false,
      cityHover: false,
      selectedSupplier: {},
      selectedFrameSupplier: {},
      selectedSupplierCityStr: ''
    }
  },
  computed: {
    ...mapState(['suppliers', 'frameSuppliers', 'loginSupplier'])
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions(['getSuppliers', 'getUserInfo', 'getFrameSuppliers', 'login']),
    // 初始化数据  获取供应商列表
    initData () {
      let loading = this.$loading()
      this.tipClass = ''
      this.tipFrameClass = ''

      this.getSuppliers().then(res => {
        if (res.data.length === 1) {
          this.selectedSupplier = res.data[0]
          // if (this.selectedSupplier.supList.length === 1) {
          //   this.chooseCity(this.selectedSupplier.supList[0])
          // }
        } else if (res.data.length === 0) {
          this.tip = '该账号无关联供应商，请联系客服 4006-135-135'
        }
      }).catch(e => {
        let { error } = e
        if (error.code < 10000) {
          this.tipClass = 'error'
          this.tip = error.msg
        } else if (error.code < 20000) {
          location.href = '/sweb/login/loginOut'
        }
      }).finally(() => {
        loading.close()
      })
      // 框架协议
      this.getFrameSuppliers().then(res => { 
        if (!res.data || !res.data.supplierQualificationManageList || res.data.supplierQualificationManageList.length === 0) {
          this.tip = '该账号无关联公司主体，请联系客服 4006-135-135'
          this.tipFrameClass = 'error'
          this.tipFrame = '该账号无关联公司主体'
        } 
      }).catch(e => {
        let { error } = e
        if (error.code && error.code < 10000) {
          this.tipFrameClass = 'error'
          this.tipFrame = error.msg
        } else if (error.code && error.code < 20000) {
          location.href = '/sweb/login/loginOut'
        } else {
          this.tipFrameClass = 'error'
          this.tipFrame = error
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 切换供应商hover状态
    toggleSupplierHover (hover) {
      if (this.suppliers.length === 0 || this.tipClass === 'error') return
      this.supplierHover = hover
    },
    toggleFrameSupplierHover (hover) {
      if (this.frameSuppliers.length === 0 || this.tipFrameClass === 'error') return
      this.supplierFrameHover = hover
    },
    // 切换城市hover状态
    toggleCityHover (hover) {
      if (this.suppliers.length === 0 || this.tipClass === 'error') return
      this.cityHover = hover
    },
    // 选择供应商
    chooseSupplier (supplier) {
      this.supplierHover = false
      this.selectedSupplier = supplier
    },
    chooseFrameSupplier (supplier) {
      this.supplierFrameHover = false
      this.selectedFrameSupplier = supplier
      let loading = this.$loading()
      this.login({ qualificationBankId: this.selectedFrameSupplier.id }).then(res => {
        this.$router.push({ name: 'frameAgreement' })   
      }).catch(e => {
        let { error } = e
        if (error.code && error.code === '0000') {
          this.tip = error.msg
        } else {
          console.error(e)
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 选择城市
    chooseCity (city) {
      this.$tracer.click('n.4186.8582.0')
      let loading = this.$loading()
      this.cityHover = false
      this.selectedSupplierCityStr = city.cityStr
      this.login({ supplierId: city.fSupplier }).then(res => {
        this.$router.push({ name: 'orderNotConfirmed' })
      }).catch(e => {
        let { error } = e
        if (error.code && error.code === '0000') {
          this.tip = error.msg
        } else {
          console.error(e)
        }
      }).finally(() => {
        loading.close()
      })
    },
    
    supplierPoolInfo () {
      this.$router.push({name: 'supplierPoolInfo'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/selectSupplier/index.vue